import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEvento = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'evento',
        name: 'Evento',
        component: ViewEvento,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
